module.exports = __webpack_public_path__ + "assets/img/soldiers_7.072443a0.png";